import {css} from 'styled-components';


export const globalStylesFontFace = css`
    @font-face {
        font-family: 'Ivy Mode';
        src: url('/fonts/IvyMode-Regular.woff2') format('woff2'),
        url('/fonts/IvyMode-Regular.woff') format('woff');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Albert Sans';
        src: url('/fonts/AlbertSans-Bold.woff2') format('woff2'),
        url('/fonts/AlbertSans-Bold.woff') format('woff');
        font-weight: bold;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Albert Sans';
        src: url('/fonts/AlbertSans-ExtraBold.woff2') format('woff2'),
        url('/fonts/AlbertSans-ExtraBold.woff') format('woff');
        font-weight: bold;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Albert Sans';
        src: url('/fonts/AlbertSans-SemiBold.woff2') format('woff2'),
        url('/fonts/AlbertSans-SemiBold.woff') format('woff');
        font-weight: 600;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Albert Sans';
        src: url('/fonts/AlbertSans-Light.woff2') format('woff2'),
        url('/fonts/AlbertSans-Light.woff') format('woff');
        font-weight: 300;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Albert Sans';
        src: url('/fonts/AlbertSans-Regular.woff2') format('woff2'),
        url('/fonts/AlbertSans-Regular.woff') format('woff');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Albert Sans';
        src: url('/fonts/AlbertSans-Medium.woff2') format('woff2'),
        url('/fonts/AlbertSans-Medium.woff') format('woff');
        font-weight: 500;
        font-style: normal;
        font-display: swap;
    }


`;

